// import React, { useEffect, useState } from 'react';
// import classes from "./MatchLayoutNew.module.css";
// import moment from "moment-timezone";
// import { useNavigate } from 'react-router-dom';

// const MatchLayoutNew = ({ match, index, fantasy_match_joined, prediction_match_joined }) => {
//   const navigate = useNavigate();
//   const [time, setTime] = useState(null);
//   const [display, setDisplay] = useState("block");

//   const matchTimer = (match_date_time) => {
//     try {
//       const liveTime  = moment();
//       const matchTime = moment.utc(match_date_time);
//       const timeLeft  = moment.duration(matchTime.diff(liveTime));

//       if (timeLeft.asMilliseconds() <= 0) {
//         setDisplay("none");
//         return;
//       }
//       const hours   = Math.floor(timeLeft.asHours());
//       const minutes = timeLeft.minutes();
//       const seconds = timeLeft.seconds();
//       setTime(`${hours}h ${minutes}m ${seconds}s`);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     if (display !== "none") {
//       const id = setInterval(() => matchTimer(match?.match_date_time), 1000);
//       return () => clearInterval(id);
//     }
//   }, [display]);

//   return (
//     <div
//       className={classes.card}
//       style={{ animationDelay: `${index * 0.07}s` }}
//     >
//       {/* ── League header ── */}
//       <div className={classes.cardHeader}>
//         <div className={classes.leagueLeft}>
//           <span className={classes.leagueBadge}>🏆</span>
//           <span className={classes.leagueName}>{match?.league_name}</span>
//         </div>

//         {display !== "none" && time ? (
//           <span className={classes.countdownPill}>
//             <span className={classes.countdownDot} />
//             {time}
//           </span>
//         ) : (
//           <span className={classes.livePill}>
//             <span className={classes.liveFlash} />
//             Live Now
//           </span>
//         )}
//       </div>

//       {/* ── Teams ── */}
//       <div className={classes.teamsRow}>
//         {/* Home */}
//         <div className={classes.team}>
//           <div className={classes.logoWrap}>
//             <img
//               src={match?.home_team_image}
//               alt={match?.home_team_name}
//               className={classes.teamLogo}
//             />
//           </div>
//           <p className={classes.teamName}>{match?.home_team_name}</p>
//         </div>

//         {/* VS centre */}
//         <div className={classes.vsBlock}>
//           <span className={classes.vsText}>VS</span>
//           <p className={classes.matchDate}>
//             {moment.utc(match?.match_date_time).local().format("ddd, DD MMM")}
//           </p>
//           <p className={classes.matchTime}>
//             {moment.utc(match?.match_date_time).local().format("hh:mm A")}
//           </p>
//         </div>

//         {/* Away */}
//         <div className={classes.team}>
//           <div className={classes.logoWrap}>
//             <img
//               src={match?.away_team_image}
//               alt={match?.away_team_name}
//               className={classes.teamLogo}
//             />
//           </div>
//           <p className={classes.teamName}>{match?.away_team_name}</p>
//         </div>
//       </div>

//       {/* ── Actions ── */}
//       <div className={classes.actionsRow}>
//         {/* Fantasy */}
//         {fantasy_match_joined ? (
//           <button
//             type="button"
//             className={`${classes.btn} ${classes.btnFantasy} ${classes.btnJoined}`}
//             onClick={() => navigate("/fantasy-game", {
//               state: { match_fixture_id: match?.match_fixture_id }
//             })}
//           >
//             <span className={classes.btnIcon}>⚽</span>
//             <span className={classes.btnText}>Check Fantasy Team</span>
//             <span className={classes.joinedBadge}>✓</span>
//           </button>
//         ) : (
//           <button
//             type="button"
//             className={`${classes.btn} ${classes.btnFantasy}`}
//             onClick={() => navigate("/create-fantasy-team", {
//               state: { match_fixture_id: match?.match_fixture_id }
//             })}
//           >
//             <span className={classes.btnIcon}>⚽</span>
//             <span className={classes.btnText}>Fantasy Team</span>
//           </button>
//         )}

//         {/* Predict */}
//         {prediction_match_joined ? (
//           <button
//             type="button"
//             className={`${classes.btn} ${classes.btnPredict} ${classes.btnJoined}`}
//             onClick={() => navigate("/prediction-game", {
//               state: { match_fixture_id: match?.match_fixture_id }
//             })}
//           >
//             <span className={classes.btnIcon}>🎯</span>
//             <span className={classes.btnText}>Predict &amp; Win</span>
//             <span className={classes.joinedBadge}>✓</span>
//           </button>
//         ) : (
//           <button
//             type="button"
//             className={`${classes.btn} ${classes.btnPredict}`}
//             onClick={() => navigate("/create-prediction", {
//               state: { match_fixture_id: match?.match_fixture_id }
//             })}
//           >
//             <span className={classes.btnIcon}>🎯</span>
//             <span className={classes.btnText}>Predict &amp; Win</span>
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MatchLayoutNew;


import React, { useEffect, useState } from 'react';
import classes from "./MatchLayoutNew.module.css";
import moment from "moment-timezone";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const REWARDS = [
  { icon: "📱", label: "SmartPhone" },
  { icon: "👕", label: "Jersey" },
  { icon: "💰", label: "Airtime" },
];

const REWARDS_SW = [
  { icon: "📱", label: "Simu Janja" },
  { icon: "👕", label: "Jezi" },
  { icon: "💰", label: "Muda wa Maongezi" },
];

const MatchLayoutNew = ({ match, index, fantasy_match_joined, prediction_match_joined }) => {
  const navigate = useNavigate();
  const [time, setTime] = useState(null);
  const [display, setDisplay] = useState("block");

  const { t } = useTranslation();

  const { selectedLanguage } = useSelector((state) => state.languageSlice);

  const matchTimer = (match_date_time) => {
    try {
      const liveTime = moment();
      const matchTime = moment.utc(match_date_time);
      const timeLeft = moment.duration(matchTime.diff(liveTime));
      if (timeLeft.asMilliseconds() <= 0) { setDisplay("none"); return; }
      const hours = Math.floor(timeLeft.asHours());
      const minutes = timeLeft.minutes();
      const seconds = timeLeft.seconds();
      setTime(`${hours}h ${minutes}m ${seconds}s`);
    } catch (err) { console.log(err); }
  };

  useEffect(() => {
    if (display !== "none") {
      const id = setInterval(() => matchTimer(match?.match_date_time), 1000);
      return () => clearInterval(id);
    }
  }, [display]);

  const handlePredict = () => {
    const route = prediction_match_joined ? "/prediction-game" : "/create-prediction";
    navigate(route, { state: { match_fixture_id: match?.match_fixture_id } });
  };

  return (
    <div className={classes.card} style={{ animationDelay: `${index * 0.07}s` }}>

      {/* ── League header ── */}
      <div className={classes.cardHeader}>
        <div className={classes.leagueLeft}>
          <span className={classes.leagueBadge}>🏆</span>
          <span className={classes.leagueName}>{match?.league_name}</span>
        </div>
        {display !== "none" && time ? (
          <span className={classes.countdownPill}>
            <span className={classes.countdownDot} />
            {time}
          </span>
        ) : (
          <span className={classes.livePill}>
            <span className={classes.liveFlash} />
            {t("80")}
          </span>
        )}
      </div>

      {/* ── Teams ── */}
      <div className={classes.teamsRow}>
        <div className={classes.team}>
          <div className={classes.logoWrap}>
            <img src={match?.home_team_image} alt={match?.home_team_name} className={classes.teamLogo} />
          </div>
          <p className={classes.teamName}>{match?.home_team_name}</p>
        </div>

        <div className={classes.vsBlock}>
          <span className={classes.vsText}>{t("86")}</span>
          <p className={classes.matchDate}>{moment.utc(match?.match_date_time).local().format("ddd, DD MMM")}</p>
          <p className={classes.matchTime}>{moment.utc(match?.match_date_time).local().format("hh:mm A")}</p>
        </div>

        <div className={classes.team}>
          <div className={classes.logoWrap}>
            <img src={match?.away_team_image} alt={match?.away_team_name} className={classes.teamLogo} />
          </div>
          <p className={classes.teamName}>{match?.away_team_name}</p>
        </div>
      </div>

      {/* ── What You Win strip ── */}
      <div className={classes.rewardsStrip}>
        <p className={classes.rewardsLabel}>{t("81")}</p>
        <div className={classes.rewardsList}>
          {(selectedLanguage==0? REWARDS : REWARDS_SW).map((r, i) => (
            <React.Fragment key={r.label}>
              <div className={classes.rewardItem}>
                <span className={classes.rewardIcon}>{r.icon}</span>
                <span className={classes.rewardText}>{r.label}</span>
              </div>
              {i < REWARDS.length - 1 && <span className={classes.rewardSep}>·</span>}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* ── Single CTA ── */}
      <div className={classes.cardFooter}>
        {prediction_match_joined ? (
          <button type="button" className={`${classes.btnPredict} ${classes.btnJoined}`} onClick={handlePredict}>
            <span className={classes.btnIcon}>🎯</span>
            <span className={classes.btnText}>{t("82")}</span>
            <span className={classes.joinedBadge}>{t("83")}</span>
          </button>
        ) : (
          <button type="button" className={classes.btnPredict} onClick={handlePredict}>
            <span className={classes.btnGlow} />
            <span className={classes.btnIcon}>🎯</span>
            <span className={classes.btnText}>{t("84")} &amp; {t("85")}</span>
            {/* <span className={classes.btnArrow}>→</span> */}
          </button>
        )}
      </div>

    </div>
  );
};

export default MatchLayoutNew;